<div
    class="vc-flex-column vc-pdf-viewer-container"
    [ngStyle]="{
        'background-color':
            !sidebarPanelVisible || activeSidebarView === pdfSidebarView.THUMBS
                ? 'var(--surface-0)'
                : 'var(--surface-1)',
    }">
    <div class="vc-flex-center vc-pdf-viewer-toolbar vc-pdf-viewer-toolbar-top">
        <div class="vc-flex-center vc-pdf-viewer-toolbar-left">
            @if (showThumbnailButton) {
                <vc-button
                    [mode]="thumbnailButtonMode"
                    iconName="photo"
                    size="small"
                    [ariaLabel]="thumbnailsLabel"
                    [tooltip]="thumbnailsLabel"
                    [disabled]="isSidebarActionDisabled"
                    (trigger)="showThumbnails()"></vc-button>
            }
            @if (showThumbnailButton && showOutlineButton) {
                <span class="vc-pdf-viewer-toolbar-divider" aria-hidden="true"></span>
            }
            @if (showOutlineButton) {
                <vc-button
                    [mode]="outlineButtonMode"
                    size="small"
                    iconName="format_list_bulleted"
                    [ariaLabel]="outlineLabel"
                    [tooltip]="outlineLabel"
                    [disabled]="isSidebarActionDisabled"
                    (trigger)="showOutline()"></vc-button>
            }
            @if (showThumbnailButton || showOutlineButton) {
                <span class="vc-pdf-viewer-toolbar-divider" aria-hidden="true"></span>
            }
        </div>
        <div class="vc-flex-center vc-pdf-viewer-toolbar-right">
            @if (totalPages > 0) {
                <span class="body-medium vc-pdf-viewer-zoom-label" aria-live="polite">{{ zoomLabel }}</span>
            }
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="zoom_out"
                [ariaLabel]="zoomOutLabel"
                [tooltip]="zoomOutLabel"
                [disabled]="isZoomOutDisabled"
                (trigger)="zoomOut()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="zoom_in"
                [ariaLabel]="zoomInLabel"
                [tooltip]="zoomInLabel"
                [disabled]="isZoomInDisabled"
                (trigger)="zoomIn()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="width_full"
                [ariaLabel]="fitToWidthLabel"
                [tooltip]="fitToWidthLabel"
                [disabled]="isFitZoomDisabled"
                (trigger)="fitToWidth()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="fit_screen"
                [ariaLabel]="fitToPageLabel"
                [tooltip]="fitToPageLabel"
                [disabled]="isFitZoomDisabled"
                (trigger)="fitToPage()"></vc-button>
            <span class="vc-pdf-viewer-toolbar-divider" aria-hidden="true"></span>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="print"
                [ariaLabel]="printLabel"
                [tooltip]="printLabel"
                [disabled]="isFileActionDisabled"
                (trigger)="printFile()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="download"
                [ariaLabel]="downloadLabel"
                [tooltip]="downloadLabel"
                [disabled]="isFileActionDisabled"
                (trigger)="downloadFile()"></vc-button>
        </div>
    </div>

    <ngx-extended-pdf-viewer
        class="vc-pdf-viewer-ngx-extended-pdf-viewer"
        [src]="src"
        height="100%"
        backgroundColor="var(--surface-0)"
        [page]="currentPage"
        [zoom]="currentZoom"
        [filenameForDownload]="filenameForDownload ?? ''"
        [sidebarVisible]="sidebarVisible"
        [activeSidebarView]="activeSidebarView"
        [showSidebarButton]="false"
        [showToolbar]="false"
        [showZoomButtons]="false"
        [showZoomDropdown]="false"
        [showBorders]="false"
        [enableDragAndDrop]="false"
        [contextMenuAllowed]="false"
        [disableForms]="true"
        [enablePrint]="true"
        [textLayer]="true"
        [showTextEditor]="false"
        [showStampEditor]="false"
        [showCommentEditor]="false"
        [showDrawEditor]="false"
        [showHighlightEditor]="false"
        [showSignatureEditor]="false"
        [spread]="spread"
        (pageChange)="onViewerPageChange($event)"
        (currentZoomFactor)="onCurrentZoomFactor($event)"
        (pdfLoaded)="onPdfLoaded($event)"
        (pagesLoaded)="onPagesLoaded($event)"
        (outlineLoaded)="onOutlineLoaded($event)"
        (activeSidebarViewChange)="onActiveSidebarViewChange($event)"
        (beforePrint)="onBeforePrint()"
        (afterPrint)="onAfterPrint()"
        (progress)="onPrintProgress($event)"
        (pdfLoadingFailed)="onPdfLoadingFailed($event)"></ngx-extended-pdf-viewer>

    <div class="vc-flex-center vc-pdf-viewer-toolbar vc-pdf-viewer-toolbar-bottom">
        <div class="vc-pdf-viewer-pages-per-view">
            @if (totalPages > 1) {
                <div class="mat-mdc-paginator-page-size-label" [id]="pagesPerViewLabelId">
                    {{ pagesPerViewLabel }}
                    <mat-form-field class="mat-mdc-paginator-page-size-select">
                        <mat-select
                            [(ngModel)]="pagesPerView"
                            [disabled]="isPagesPerViewDisabled"
                            [aria-labelledby]="pagesPerViewLabelId"
                            disableOptionCentering
                            hideSingleSelectionIndicator
                            (selectionChange)="onPagesPerViewChange()">
                            @for (option of pagesPerViewOptions; track option) {
                                <mat-option [value]="option">{{ option }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }
        </div>
        <div class="vc-flex-center vc-pdf-viewer-toolbar-right">
            @if (totalPages > 0) {
                <span class="body-medium vc-pdf-viewer-page-label">{{ pageLabel }}</span>
            }
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="first_page"
                [ariaLabel]="firstPageLabel"
                [tooltip]="firstPageLabel"
                [disabled]="isFirstPageDisabled"
                (trigger)="goToFirstPage()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="chevron_left"
                [ariaLabel]="previousPageLabel"
                [tooltip]="previousPageLabel"
                [disabled]="isFirstPageDisabled"
                (trigger)="goToPreviousPage()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="chevron_right"
                [ariaLabel]="nextPageLabel"
                [tooltip]="nextPageLabel"
                [disabled]="isLastPageDisabled"
                (trigger)="goToNextPage()"></vc-button>
            <vc-button
                mode="icon-tertiary"
                size="small"
                iconName="last_page"
                [ariaLabel]="lastPageLabel"
                [tooltip]="lastPageLabel"
                [disabled]="isLastPageDisabled"
                (trigger)="goToLastPage()"></vc-button>
        </div>
    </div>
</div>

<vc-dialog
    [(visible)]="showPrintProgressDialog"
    [title]="printProgressTitle"
    width="400px"
    [showPrimary]="false"
    [showSecondary]="true"
    [secondaryLabel]="printCancelLabel"
    [closeOnSecondary]="false"
    [showCloseIcon]="false"
    [closeOnClickOutside]="false"
    (secondaryTrigger)="cancelPrint()">
    <div class="vc-flex-column vc-pdf-viewer-print-progress">
        <span class="body-medium">{{ printProgressMessage }}</span>
        <vc-progress-bar [value]="printProgressPercent" color="var(--icon-primary)"></vc-progress-bar>
    </div>
</vc-dialog>

<vc-dialog
    [visible]="passwordPrompt.showDialog()"
    [title]="passwordDialogTitle"
    width="400px"
    [showPrimary]="true"
    [showSecondary]="true"
    [primaryLabel]="passwordOkLabel"
    [secondaryLabel]="passwordCancelLabel"
    [closeOnPrimary]="false"
    [closeOnSecondary]="false"
    [showCloseIcon]="false"
    [closeOnClickOutside]="false"
    (primaryTrigger)="passwordPrompt.submit()"
    (secondaryTrigger)="cancelPasswordPrompt()">
    <div class="vc-flex-column vc-pdf-viewer-password-dialog">
        <span class="body-medium">{{ passwordDialogMessage }}</span>
        <vc-input
            #passwordInput
            [label]="passwordInputLabel"
            [value]="passwordPrompt.passwordValue()"
            (valueChange)="passwordPrompt.setPasswordValue($event)"
            type="password"
            [autoFocus]="true"
            [allowPasswordManager]="false"
            (keyupEnter)="passwordPrompt.submit()"></vc-input>
    </div>
</vc-dialog>
